import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	closeLabel: {
		id: 'servicedesk-insight-object-graph.graph-header.close-label',
		defaultMessage: 'Close',
		description: 'Label for button that closes the CMDB Object graph view',
	},
});
